module.exports = __webpack_public_path__ + "img/order-success.8572ae0f.png";